import { type Role } from '#shared/lib/roles';
import { useState } from 'nuxt/app';

export function useUserRoles() {
  return useState<Role[] | undefined>('userRoles', undefined);
}
